import styled, { css } from 'styled-components';
import { NavBarHeight, SubNavBarHeight } from '../../../const';

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0;

  @media ${props => props.theme.device.tablet} {
    overflow: overlay;
    white-space: nowrap;
    height: 100vh;
    flex-direction: column;
    height: 100%;
    position: absolute;
    top: 89px;
    left: 0px;
    align-items: flex-start;
     width: 100%; 
    padding-right: 0px; 
    padding-left: 0px;
    margin-right: auto; 
    margin-left: auto; 
   justify-content: start;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
`;

export const Wrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;
  margin: auto;

  @media ${props => props.theme.device.tablet} {
    width: 100%;
    margin: 0;
    flex-direction: column;
  }
`;

export const SubMenuElementContainer = styled.div`
  cursor: pointer;
  position: relative;
  max-width: 140px;
  height: 60px;
  display: flex;
  align-items: center;
  text-align: center;
  transition: ${props => props.theme.constants.transitionBase};
  &:hover {
    color: ${props => props.theme.colors[props.color]};
  }
  ${props => props.active
    && css`
      &:after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: -10px;
        background-color: ${props.theme.colors[props.color]};
        height: 4px;
        width: calc(100% + 20px);
      }
    `};
  @media ${props => props.theme.device.tablet} {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 59px;
    width: 100%;
    border: 1px solid #6d6f78;
    max-width: 100%;
    text-align: start;

    &:after {
      bottom: 73px;
      left: -10px;
    }
  }

  @media ${props => props.theme.device.tablet} {
    display: flex;
    padding: 20px;
    font-size: 14px;

    ${props => props.active
      && css`
        &:after {
          /*
          content: '';
          position: absolute;
          bottom: -8px;
          left: -168px;
          background-color: ${props.theme.colors.primaryColor};
          height: 4px;
          width: 100px;
           width: calc(100% + 20px); 
           */
          margin-right: 0px;
          content: '';
          position: absolute;
          bottom: 0px;
          left: 0;
          background-color: #258900;
          height: 100%;
          width: 4px;
        }
      `};
  }
`;

export const SubNavBarContainer = styled.div`
  position: fixed;
  width: 100%;
  height: ${SubNavBarHeight}px;
  box-shadow: -8px 7px 10px 1px rgb(27 27 27 / 45%);
  color: ${props => props.theme.colors.white};
  padding: 0 2rem;
  z-index: ${props => props.theme.zIndex.navBar};
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  top: ${NavBarHeight}px;
  left: 0;
  background-color: #1f2025;

  font-family: ${props => props.theme.fontset.arial};
  font-weight: 700;
  font-size: 14px;
  line-height: 1.14;

  &.header-wrapper {
    width: 100%;
    margin: 0;
    position: fixed;
    top: ${NavBarHeight}px;
    left: 0;
    z-index: ${props => props.theme.zIndex.headerWrapper};
    margin-left: auto;
  }

  @media ${props => props.theme.device.tablet} {
    padding: 0 30px;
    div {
      div {
        div {
          .close-modal {
            outline: none;
            animation: fadein 1s;
            background-color: ${props => props.theme.colors.transparent};
            border: none;
            display: block;
            padding: 20px;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 20px;
            height: 20px;
            z-index: ${props => props.theme.zIndex.closeModal};

            &::after {
              content: '';
              position: absolute;
              transform: rotate(-45deg);
              background-color: ${props => props.theme.colors.white};
              height: 20px;
              width: 1px;
              top: 10px;
              z-index: ${props => props.theme.zIndex.closeModal};
            }

            &::before {
              content: ' ';
              position: absolute;
              transform: rotate(45deg);
              background-color: ${props => props.theme.colors.white};
              height: 20px;
              width: 1px;
              top: 10px;
              z-index: ${props => props.theme.zIndex.closeModal};
            }
          }
        }
      }
    }
  }

  @media ${props => props.theme.device.tablet} {
    display: none;
  }

  @media ${props => props.theme.device.tablet && !props.navigationMobile} {
    display: block;
    height: 100%;
    padding: 0 20px;
    margin-top: 50px;
    width: 80%;
    left: 30%;
    top: 0;

    general-container div {
      height: 100vh;
      flex-direction: column;
      padding: 0;
      div {
        div {
          white-space: nowrap;
          margin-right: 20px;
          margin-left: 0px;
        }
      }
    }
  }

  ${({ arabic }) => arabic && css`
  
    @media ${props => props.theme.device.tablet && !props.navigationMobile} {
      left: auto;
      right: 30%;
    }

    ${Wrapper} {
      flex-direction: row-reverse;

      @media ${props => props.theme.device.tablet} {
        flex-direction: column;
      }
    }

    ${SubMenuElementContainer} {
      > div {
        text-align: right !important;
      }
    }
  `}
`;
